/* istanbul ignore file */
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import { Config } from "./Config";
import { Configuration, PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import reportWebVitals from "./reportWebVitals";

const theme = createTheme({
  typography: {
    fontFamily: "Lato",
  },
  palette: {
    primary: {
      main: "#592C82",
    },
  },
});

const msalConfig: Configuration = {
  auth: {
      clientId: Config.msal.clientId,
      authority: Config.msal.domain,
      redirectUri: window.location.origin
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    ReactDOM.render(
      <Router>
        <MsalProvider instance={msalInstance}>
          <ThemeProvider theme={theme}>
            <App instance={ msalInstance } />
          </ThemeProvider>
        </MsalProvider>
      </Router>,
      document.getElementById("root")
    );
});

reportWebVitals();
